module.exports = __webpack_public_path__ + "static/media/Logo__CEC.603f1072.svg";